import React from 'react';
import CVBuilder from './CVBuilder';
import AnalyticsConsent from './AnalyticsConsent';
import './App.css';

function App() {
  return (
    <>
      <CVBuilder />
      <AnalyticsConsent />
    </>
  );
}

export default App;
